import { LocalDate, DateTimeFormatter } from "@js-joda/core";
import { registerAiCapability } from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";
import moment from "moment";
import $ from "jquery";

/**
 * INSPINIA - Responsive Admin Theme
 *
 */

/**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
//! @ngInject
export function sideNavigation($timeout, $state) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            // Call the metsiMenu plugin and plug it to sidebar navigation
            $timeout(function(){
                // element.metisMenu(); // @VITE_REFACTOR - Seems like it doesn't do anything
            });

            // The sidebar owns navigation, so it is the one that tells the AI omnibar the app
            // can be navigated. It deliberately does not hold a list of pages: every
            // destination is contributed by the side-navigation-item that renders it, so what
            // the AI can reach is exactly what this user can see. See
            // side-navigation-item.directive.js.
            const releaseNavigateCapability = registerAiCapability(
                {
                    id: "app.navigate",
                    title: "Go to a page",
                    effect: "navigate",
                    description:
                        "Navigates the main window to one of the pages in the left hand navigation.",
                    location: "the left hand navigation, on every page",
                    // Being on a page is what makes that page's own capabilities - its filters,
                    // mostly - reachable. They declare scope: "page".
                    opens: ["page"],
                    params: [
                        {
                            name: "destination",
                            type: "enum",
                            required: true,
                            description: "Which page to open."
                        }
                    ],
                    examples: ["take me to the patients list", "open billing invoices"]
                },
                function (args) {
                    // No `reload: true` here on purpose: reloading the `app` state re-links the
                    // navbar, which would throw away the omnibar panel that is reporting this
                    // very step.
                    return $timeout(function () {
                        $state.go(String(args.destination));
                    });
                }
            );

            scope.$on("$destroy", releaseNavigateCapability);
        }
    };
};

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
//! @ngInject
export function iboxTools($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'views/common/ibox_tools.html',
        //! @ngInject
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            },
                // Function for close ibox
                $scope.closebox = function () {
                    var ibox = $element.closest('div.ibox');
                    ibox.remove();
                }
        }
    };
};

/**
 * minimalizaSidebar - Directive for minimalize sidebar
 */
//! @ngInject
export function minimalizaSidebar($timeout, $rootScope) {
    return {
        restrict: 'E',
        transclude: true,
        template: '<div ng-click="minimalize()"><div ng-transclude></div></div>',
        //! @ngInject
        controller: function ($scope, $element, $rootScope) {
          $scope.minimalize = function () {
            $rootScope.sidenavFocus();
            $("body").toggleClass("mini-navbar");
            if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                // Hide menu in order to smoothly turn on when maximize menu
                $('#side-menu').hide();
                // For smoothly turn on menu
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(400);
                    }, 200);
            } else if ($('body').hasClass('fixed-sidebar')){
                $('#side-menu').hide();
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(400);
                    }, 100);
            } else {
                // Remove all inline style from jquery fadeIn function to reset menu state
                $('#side-menu').removeAttr('style');
            }
          }
        }
    };
};

/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
//! @ngInject
export function iboxToolsFullScreen($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'views/common/ibox_tools_full_screen.html',
        //! @ngInject
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            };
            // Function for close ibox
            $scope.closebox = function () {
                var ibox = $element.closest('div.ibox');
                ibox.remove();
            };
            // Function for full screen
            $scope.fullscreen = function () {
                var ibox = $element.closest('div.ibox');
                var button = $element.find('i.fa-expand');
                $('body').toggleClass('fullscreen-ibox-mode');
                button.toggleClass('fa-expand').toggleClass('fa-compress');
                ibox.toggleClass('fullscreen');
                setTimeout(function() {
                    $(window).trigger('resize');
                }, 100);
            }
        }
    };
}

//! @ngInject
export function fileModel($parse) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      element.bind('change', function(){
        scope.$apply(function(){
            modelSetter(scope, element[0].files[0]);
        });
      });
    }
  };
}

//! @ngInject
export function glue($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attr) {
      scope.$watchCollection(attr.glue, function(newVal) {
        $timeout(function() {
         element[0].scrollTop = element[0].scrollHeight;
         scope.$apply();
        }, 100);
      });
    }
  }
};


export function capitalize() {
    return function(input) {
      if(!input) return input;
      return (!!input) ? (input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()).replaceAll("_", " ") : '';
    }
};

export function titlecase() {
    return function(input) {
        var text = input;
        var result = text.replace( /([A-Z])/g, " $1" );
        return result.charAt(0).toUpperCase() + result.slice(1);
    }
};

//! @ngInject
export function percentage ($filter) {
    return function (input, decimals) {
        return $filter('number')(input * 100, decimals) + '%';
    };
}

export function secondsToTimeFilter() {

    function padTime(t) {
        return t < 10 ? "0"+t : t;
    }

    return function(_seconds) {
        if (typeof _seconds !== "number" || _seconds < 0)
            return "00:00:00";

        var hours = Math.floor(_seconds / 3600),
            minutes = Math.floor((_seconds % 3600) / 60),
            seconds = Math.floor(_seconds % 60);

        return padTime(hours) + ":" + padTime(minutes) + ":" + padTime(seconds);
    };
};

export function secondsToLabelFilter() {
  return function(seconds) {
    if (!seconds && seconds !== 0) return '';
    const duration = moment.duration(Math.abs(seconds), 'seconds');
    const hours = Math.floor(duration.asHours());
    if (hours > 0) duration.subtract(hours, "hours");
    let minutes = Math.floor(duration.asMinutes());
    if (minutes < 10) minutes = '0' + minutes;
    const sign = Math.sign(seconds) === -1 ? '-' : '';
    return `${sign}${hours}:${minutes} hr`;
  }
};

export function replacebrFilter() {
    return function(input) {
        var result = input.replace( /<br>/g, "/n" );
        return result;
    }
};

export function phonenumberFilter() {
    return function(input) {
      if (!input || input === 'empty') return input;
      input = input.replace(/(\+1|\(|\)| |-)/g, "");
      var result = '(';
      result += input.substring(0,3) + ') ';
      result += input.substring(3,6) + '-';
      result += input.substring(6,10);
      return result;
    }
};

export function objToArrayFilter(){
    return function(obj) {
        var result = [];
        angular.forEach(obj, function(val, key) {
            // console.log(val);
            result.push(val);
        });
        // console.log(result);
        return result;
    };
};

export function americanphoneFilter() {
    return function(input) {
      //console.log(input);
      if(!input || input === '' || input === 'empty') return input;

      //input = input.replace('+','');
      if(input.substring(0,4) === '+972') {
        var result = '+972 ';
        input = input.substr(4);
      }else {
        var result = '+1 ';
        if( input.length > 10)input = input.substr(2);
      }
      result += '(' + input.substring(0,3) + ') ';
      result += input.substring(3,6) + '-';
      result += input.substring(6,10);
      return result;
    }
};

export function hiddenphoneFilter() {
    return function(input) {
      if(!input || input === '' || input === 'empty') return input;

      var result = input.substring(0,13);
      result += '****';
      return result;
    }
};

//! @ngInject
export function centsToDollarsFilter($filter) {
  return function(input, isForExport = false) {
    if(isNaN(input) || input === '') return input;
    const result = $filter('currency')((Number(input) / 100).toFixed(2));
    if (isForExport) return result;
    return result.toLocaleString();
  }
};


export function ssnFilter () {
    return function (ssn) {

        if (!ssn) { return ''; }

        if (ssn === 'empty') {
          return ssn;
        }

        var value = ssn.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) return ssn;

        var three = value.slice(0, 3);
        var six = value.slice(3);

        if (six) {

            if(six.length > 2) six = six.slice(0, 2) + '-' + six.slice(2,6);

            return (three + "-" + six).trim();

        } else return three;
    };
};

export function hoursMinutesFilter () {
    return function (val) {

        if (!val) { return '00:00'; }

        var time = {};
        time.hours =  Math.floor(val / 60);
        time.minutes = val - (time.hours * 60);

        console.log(val);
        console.log(time.hours);
        console.log(time.minutes);

        var string = '';
        if(time.hours < 10) string += '0' + time.hours;
        else string += time.hours;

        string += ':';

        if(time.minutes < 10) string += '0' + time.minutes;
        else string += time.minutes;

        return string;

    };
};

export function timeFilter() {

    var conversions = {
      'ss': angular.identity,
      'mm': function(value) { return value * 60; },
      'hh': function(value) { return value * 3600; }
    };

    var padding = function(value, length) {
      var zeroes = length - ('' + (value)).length,
          pad = '';
      while(zeroes-- > 0) pad += '0';
      return pad + value;
    };

    return function(value, unit, format, isPadded) {
      var totalSeconds = conversions[unit || 'ss'](value),
          hh = Math.floor(totalSeconds / 3600),
          mm = Math.floor((totalSeconds % 3600) / 60),
          ss = totalSeconds % 60;

      format = format || 'hh:mm:ss';
      isPadded = angular.isDefined(isPadded)? isPadded: true;
      hh = isPadded? padding(hh, 2): hh;
      mm = isPadded? padding(mm, 2): mm;
      ss = isPadded? padding(ss, 2): ss;

      return format.replace(/hh/, hh).replace(/mm/, mm).replace(/ss/, ss);
    };
  };

    export function dateRangeFilter () {
        return function(items, from, to) {
            if (from==null || from=="" || to==null || to==""){
                return items;
            }
            var df =  Date.parse(from);
            var dt = Date.parse(to);
            var result = [];
            for (var i = 0; i < items.length; i++) {
                var date_bet =  Date.parse(items[i].createdAt);
                if (date_bet > df && dt > date_bet) {
                    result.push(items[i]);
                }
            }
            return result;
        };
    };

    export function matchItemsFilter () {
        return function (items, type, id) {
            var filtered = [];
            if(!id) return filtered;
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item[type] === id && item.name !== 'Documents') {
                    filtered.push(item);
                }
            }
            return filtered;
        };
    };

export function dateStringToLocaleDateFilter() {
  return function (dateTimeValue) {
    if (/^\d\d\d\d-\d\d-\d\d$/.test(dateTimeValue)) {
      return new Date(dateTimeValue + " 00:00:00").toLocaleDateString();
    } else {
      return new Date(dateTimeValue).toLocaleDateString();
    }
  };
};

export function instantStringToLocaleDateTime() {
    return function (dateTimeValue) {
      if (/^\d\d\d\d-\d\d-\d\d$/.test(dateTimeValue)) {
        return new Date(dateTimeValue).toLocaleString();
      } else {
        return new Date(dateTimeValue).toLocaleString();
      }
    };
};

//! @ngInject
export function hourMinutesRangeFilter($filter) {
  return function (item, startTimePropertyName, endTimePropertyName) {
    if(!item) return;

    var startDateTime = item[startTimePropertyName] && new Date(item[startTimePropertyName]);
    var endDateTime = item[endTimePropertyName] && new Date(item[endTimePropertyName]);
    const startTimeString = startDateTime ? $filter("mfShortTime")(startDateTime) : "";
    var betweenString = (startDateTime || endDateTime) ? " - " : "";
    const endTimeString = endDateTime ? $filter('mfShortTime')(endDateTime) : "";
    return startTimeString + betweenString + endTimeString;
  };
};

export function pipeItemsFilter () {
  return function (items, propertyName) {
    var pipedValues = "";
    var getValue = propertyName
      ? function (itemIndex) { return items[itemIndex][propertyName]; }
      : function (itemIndex) { return items[itemIndex]; };

    if (items && items.length > 0) {
        pipedValues += getValue(0);
        for (var idx = 1; idx < items.length; idx++) {
            pipedValues += "|" + getValue(idx);
        }
    }
    return pipedValues;
  };
};

export function displayFullNameFilter () {
  return function (itemWithNameFields, firstNamePropertyName, middleNamePropertyName, lastNamePropertyName) {
    var firstName = itemWithNameFields.firstName || itemWithNameFields[firstNamePropertyName];
    var middleName = itemWithNameFields.middleName || itemWithNameFields[middleNamePropertyName];
    var lastName = itemWithNameFields.lastName || itemWithNameFields[lastNamePropertyName];

    var fullNameToDisaply = firstName;
    if (middleName) { fullNameToDisaply += " " + middleName.substr(0, 1) + "."; }
    fullNameToDisaply += " " + lastName;

    return fullNameToDisaply;
  };
};

export function onErrorSrc() {
  return {
      link: function(scope, element, attrs) {
        element.bind('error', function() {
          if (attrs.src != attrs.onErrorSrc) {
            attrs.$set('src', attrs.onErrorSrc);
          }
        });
      }
  }
};

//! @ngInject
export function focusMe($timeout) {
  return {
    scope: { trigger: '@focusMe' },
    link: function(scope, element) {
      scope.$watch('trigger', function(value) {
        if(value === "true") {
          $timeout(function() {
            element[0].focus();
          });
        }
      });
    }
  };
};

export function ssn() {
    function makeSsn (value) {
      var result = value;

      var ssn = value ? value.toString() : '';
      if (ssn.length === 11) {
        return ssn;
      }
      if (ssn.length > 3) {
        result = ssn.substr(0, 3) + '-';
        if (ssn.length > 5) {
          result += ssn.substr(3, 2) + '-';
          result += ssn.substr(5, 4);
        }
        else {
          result += ssn.substr(3);
        }
      }

      return result;
    }

    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$formatters.push(function (value) {
          return makeSsn(value);
        });

        // clean output as digits
        ngModel.$parsers.push(function (value) {
          var cursorPosition = element[0].selectionStart;
          var oldLength = value.toString().length;
          var nonDigits = /[^0-9]/g;
          var intValue = value.replace(nonDigits, '');
          if (intValue.length > 9) {
            intValue = intValue.substr(0, 9);
          }
          var newValue = makeSsn(intValue);
          ngModel.$setViewValue(newValue);
          ngModel.$render();
          element[0].setSelectionRange(cursorPosition + newValue.length - oldLength, cursorPosition + newValue.length - oldLength);
          return newValue;
        });
      }
    };
};

export function uppercase() {
  return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
          modelCtrl.$parsers.push(function(input) {
              return input ? input.toUpperCase() : "";
          });
          element.css("text-transform","uppercase");
      }
  };
};

export function secondsToDateTimeFilter() {
    return function(seconds) {
        if(!seconds) seconds = 0;
        return new Date(1970, 0, 1).setSeconds(seconds);
    };
};

export function hourMinutesToDateTimeFilter() {
    return function(hours, minutes) {
      const date = new Date();
      date.setHours(hours || 0);
      date.setMinutes(minutes || 0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date;
    };
};

export function csvValueWithCommaFilter() {
    return function(value) {
      if (value) return '"' + value + '"';
      return "";
    };
};

export function filterByNameAndCodeFilter() {
  return function(items, name, visitId, patient) {
        let result = {};
        let regex;
        try{
          regex = new RegExp(name, 'i');
        } catch(e){
          name = false;
        }
        if (!name || name === '') return result;
        else {
          angular.forEach(items, function(value, key) {
            const match = regex.test(value.displayName) || regex.test(value.caregiverCode) || regex.test(value.displayId)
            if (match && Object.keys(result).length < 5) {

              value.chatRoomType = {
                visitId: visitId,
                caregiverId: parseInt(key),
                patientId: patient ? patient.id : null,
                type: 'CaregiverPatientChat'
              };

              value.members = [
                {
                  lastViewed: null,
                  user: {
                    caregiverId: value.id,
                    type: 'Caregiver'
                  }
                }
              ];

              value.messages = [];
              value.photoUrl = value.photoUrl || 'admin/images/blank-profile.jpg';
              value.caregiverLastViewd = null;
              value.agencyLastViewd = null;
              value.displayName = value.displayName;
              value.fromList = true;

              result[key] = value;
            }
          });
          return result;
        }
    };
};

export function joinFilter () {
  return function join(array, separator, prop) {
    if (!Array.isArray(array)) {
      return array; // if not array return original - can also throw error
    }

    return (!!prop ? array.map(function (item) {
      return item[prop];
    }) : array).join(separator);
  };
};

//! @ngInject
export function mfShortDateFilter($filter) {
  return function mfShortDate(date, timezone) {
    if (!date) {
      return date;
    }

    const pattern = "MM/dd/yyyy";

    if (date instanceof LocalDate) {
      return date.format(DateTimeFormatter.ofPattern(pattern));
    }

    return $filter("date")(date, pattern, timezone);
  };
};

//! @ngInject
export function mfShortDayOfWeekFilter($filter) {
  return function mfShortDate(date) {
    if (!date || typeof date !== "string") {
      return date;
    }

    try {
      switch (LocalDate.parse(date).dayOfWeek().name()) {
        case "SUNDAY": return 'Sun';
        case "MONDAY": return 'Mon';
        case "TUESDAY": return 'Tue';
        case "WEDNESDAY": return 'Wed';
        case "THURSDAY": return 'Thu';
        case "FRIDAY": return 'Fri';
        case "SATURDAY": return 'Sat';
        default: return date;
      }
    } catch (e) {
      return date;
    }
  };
};

//! @ngInject
export function formatPatientContractFilter($filter) {
  return function(patientContract) {
      if (patientContract.id === null && patientContract.name ) return patientContract.name;
      if (patientContract.id === null) return;

      const name = patientContract.contractTypeName || patientContract.name;
      const endDate = $filter("date")(patientContract.endDate, "MM/dd/yyyy") || "Present";

      const build = [
        name,
        '|',
        $filter("date")(patientContract.startDate, "MM/dd/yyyy"),
        '-',
        endDate
      ];

      const extra = [];

      if (patientContract.isPrimary) {
        extra.push("Primary");
      }

      if (patientContract.isOnHold) {
        extra.push("On Hold");
      }

      const isActive = (patientContract.endDate === null || patientContract.endDate === undefined || LocalDate.parse(patientContract.endDate).isAfter(LocalDate.now()))
        && !patientContract.isOnHold;
      if (!isActive) {
        extra.push("Inactive");
      }

      if (extra.length > 0) {
        build.push("(" + extra.join(", ") + ")");
      }

      return build.join(" ");
  }
};

export function objectSizeFilter() {
  return function(obj) {
    if (typeof obj !== "object") {
      return obj;
    }
    return Object.keys(obj).length;
  }
};

export function includeReplace() {
    return {
        require: 'ngInclude',
        restrict: 'A', /* optional */
        link: function (scope, el, attrs) {
            el.replaceWith(el.children());
        }
    };
};

export function checkedButton()  {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    templateUrl: 'admin/views/checked-button.html',
    scope: {
        text: '@',
        isChecked: '='
    }
  };
};

export function styledLabel() {
  return {
    restrict: 'E',
    templateUrl: 'admin/views/styledLabel.html',
    scope: {
      text: '@',
      colorClass: '<',
      color: '<',
      backgroundColor: '<',
      size: '<'
    }
  };
};

export function styledBadge() {
  return {
    restrict: 'E',
    templateUrl: 'admin/views/styledBadge.html',
    scope: {
      text: '@',
      colorClass: '@'
    }
  };
};

export function fileUrlField()  {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'admin/views/file-url-field.html',
    scope: {
      url: '@',
      name: '@',
    }
  };
};

export function introVideo()  {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'admin/views/intro-video.html',
    scope: {
        key: '@',
        title: '@',
        description: '@',
        youtubeVideoId: '@'
    },
    //! @ngInject
    controller: function($scope, $element, $sce) {
      $scope.showContainer = !(sessionStorage.getItem($scope.key) || localStorage.getItem($scope.key));
      $scope.videoUrl = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + $scope.youtubeVideoId);
      $scope.hideVideoContainer = function (forever) {
          var storage = forever ? localStorage : sessionStorage;
          $scope.showContainer = false;
          storage.setItem($scope.key, 'true');
      }
    }
  };
};

//! @ngInject
export function callsMissedTable($rootScope) {
  return {
    restrict: 'E',
    templateUrl: 'admin/views/calls-missed-table.html',
    scope: {
      tableParams: '='
    },
    link: function (scope, elem, attr) {
      scope.openMissedVisit = function (visitId) {
        return $rootScope.openVisitInstanceModal(visitId);
      };
    }
  };
};

export function clockLocationBound() {
  return {
    restrict: 'E',
    templateUrl: 'admin/views/clock-location-bound.html',
    scope: {
      patientLocation: '=',
      clockLocation: '=',
      clockLocationType: "=",
      clockType: '@'
    },
    controller: 'clockLocationBoundCtrl'
  };
};

//! @ngInject
export function viewPermission($rootScope) {
  return {
    scope: { permissionKey: '@viewPermission' },
    link: function(scope, element) {
      scope.$watch('permissionKey', function(value) {
        if (value === "") {
          return;
        }
        const valuePermissions = value.split("|");
        if(valuePermissions.every(valuePermission => !$rootScope.isPermittedByKey(valuePermission))) {
          angular.element(element).remove();
        }
      });
    }
  };
}

//! @ngInject
export function viewPermissionSome($rootScope) {
  return {
    scope: { permissionKey: '@viewPermission' },
    link: function(scope, element) {
      scope.$watch('permissionKey', function(value) {
        if (value === "") {
          return;
        }
        const valuePermissions = value.split("|");

        if(valuePermissions.some(valuePermission => !$rootScope.isPermittedByKey(valuePermission))) {
          angular.element(element).remove();
        }
      });
    }
  };
};

export function roundedCheckbox() {
  return {
    restrict: 'E',
    templateUrl: 'admin/views/rounded-checkbox.html',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      readOnly: '=',
      id: '=',
      label: '=',
      onChange: '&'
    }
  };
};

/**
 * Checklist-model
 * AngularJS directive for list of checkboxes
 * https://github.com/vitalets/checklist-model
 * License: MIT http://opensource.org/licenses/MIT
 */

 /* commonjs package manager support (eg componentjs) */
 if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
   module.exports = 'checklist-model';
 }

angular.module('checklist-model', [])
.directive('checklistModel', ['$parse', '$compile', function($parse, $compile) {
  // contains
  function contains(arr, item, comparator) {
    if (angular.isArray(arr)) {
      for (var i = arr.length; i--;) {
        if (comparator(arr[i], item)) {
          return true;
        }
      }
    }
    return false;
  }

  // add
  function add(arr, item, comparator) {
    arr = angular.isArray(arr) ? arr : [];
      if(!contains(arr, item, comparator)) {
          arr.push(item);
      }
    return arr;
  }

  // remove
  function remove(arr, item, comparator) {
    if (angular.isArray(arr)) {
      for (var i = arr.length; i--;) {
        if (comparator(arr[i], item)) {
          arr.splice(i, 1);
          break;
        }
      }
    }
    return arr;
  }

  // http://stackoverflow.com/a/19228302/1458162
  function postLinkFn(scope, elem, attrs) {
     // exclude recursion, but still keep the model
    var checklistModel = attrs.checklistModel;
    attrs.$set("checklistModel", null);
    // compile with `ng-model` pointing to `checked`
    $compile(elem)(scope);
    attrs.$set("checklistModel", checklistModel);

    // getter for original model
    var checklistModelGetter = $parse(checklistModel);
    var checklistChange = $parse(attrs.checklistChange);
    var checklistBeforeChange = $parse(attrs.checklistBeforeChange);
    var ngModelGetter = $parse(attrs.ngModel);



    var comparator = function (a, b) {
      if(!isNaN(a) && !isNaN(b)) {
        return String(a) === String(b);
      } else {
        return angular.equals(a,b);
      }
    };

    if (attrs.hasOwnProperty('checklistComparator')){
      if (attrs.checklistComparator[0] == '.') {
        var comparatorExpression = attrs.checklistComparator.substring(1);
        comparator = function (a, b) {
          return a[comparatorExpression] === b[comparatorExpression];
        };

      } else {
        comparator = $parse(attrs.checklistComparator)(scope.$parent);
      }
    }

    // watch UI checked change
    var unbindModel = scope.$watch(attrs.ngModel, function(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
        ngModelGetter.assign(scope, contains(checklistModelGetter(scope.$parent), getChecklistValue(), comparator));
        return;
      }

      setValueInChecklistModel(getChecklistValue(), newValue);

      if (checklistChange) {
        checklistChange(scope);
      }
    });

    // watches for value change of checklistValue
    var unbindCheckListValue = scope.$watch(getChecklistValue, function(newValue, oldValue) {
      if( newValue != oldValue && angular.isDefined(oldValue) && scope[attrs.ngModel] === true ) {
        var current = checklistModelGetter(scope.$parent);
        checklistModelGetter.assign(scope.$parent, remove(current, oldValue, comparator));
        checklistModelGetter.assign(scope.$parent, add(current, newValue, comparator));
      }
    }, true);

    var unbindDestroy = scope.$on('$destroy', destroy);

    function destroy() {
      unbindModel();
      unbindCheckListValue();
      unbindDestroy();
    }

    function getChecklistValue() {
      return attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;
    }

    function setValueInChecklistModel(value, checked) {
      var current = checklistModelGetter(scope.$parent);
      if (angular.isFunction(checklistModelGetter.assign)) {
        if (checked === true) {
          checklistModelGetter.assign(scope.$parent, add(current, value, comparator));
        } else {
          checklistModelGetter.assign(scope.$parent, remove(current, value, comparator));
        }
      }

    }

    // declare one function to be used for both $watch functions
    function setChecked(newArr, oldArr) {
      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
        setValueInChecklistModel(getChecklistValue(), ngModelGetter(scope));
        return;
      }
      ngModelGetter.assign(scope, contains(newArr, getChecklistValue(), comparator));
    }

    // watch original model change
    // use the faster $watchCollection method if it's available
    if (angular.isFunction(scope.$parent.$watchCollection)) {
        scope.$parent.$watchCollection(checklistModel, setChecked);
    } else {
        scope.$parent.$watch(checklistModel, setChecked, true);
    }
  }

  return {
    restrict: 'A',
    priority: 1000,
    terminal: true,
    scope: true,
    compile: function(tElement, tAttrs) {

      if (!tAttrs.checklistValue && !tAttrs.value) {
        throw 'You should provide `value` or `checklist-value`.';
      }

      // by default ngModel is 'checked', so we set it if not specified
      if (!tAttrs.ngModel) {
        // local scope var storing individual checkbox model
        tAttrs.$set("ngModel", "checked");
      }

      return postLinkFn;
    }
  };
}]);

export function mfActiveOnScroll() {
  return {
    link: function(scope, element, attrs) {
      element.on("scroll", function(e) {
        const attr = attrs["mfActiveOnScroll"];
        if (scope[attr]) {
          const scrollTop = element.scrollTop();
          const children = Array.from(element.children());
          let activeChild = children[0];
          for (const child of children) {
            if (child.offsetTop + child.scrollHeight >= scrollTop) {
              activeChild = child;
              break;
            }
          }

          scope.$apply(scope[attr](activeChild));
        }
      });
    }
  };
};

export function mfPreventNewLine() {
    return {
        link: function(scope, element, attributes) {
            element.on("keydown", (event) => {
                    if (event.which === 13) {
                        event.preventDefault();
                    }
                }
            );
        }
    };
};

export function mfTextareaAutoHeight() {
    return {
        link: function(scope, element, attributes) {
            const updateTextarea = (element) => {
                element.css({ height: 0, minHeight: 0, maxHeight: 0 });
                const { scrollHeight = 0 } = element.context;
                element.css({
                    height: `${scrollHeight}px`,
                    minHeight: 0,
                    maxHeight: `${scrollHeight}px`
                });
            };

            const transformInNoTransition = (element, transformer) => {
                element.addClass("notransition");
                transformer(element);
                element.height(); // this is hack to force redraw before apply transition, to avoid use $timeout
                element.removeClass("notransition");
            };

            const updateTextAreaHeight = () => {
                transformInNoTransition(element, updateTextarea);
            };

            scope.$watch(attributes.ngModel, updateTextAreaHeight);
            element.on("keydown", updateTextAreaHeight);
        }
    };
};
